const reIsBadHex = /^[-+]0x[0-9a-f]+$/i
export default reIsBadHex
